import { isCarvanaNativeApp } from '@carvana/core-native-messaging';
import sendNativeEvent from '|/helpers/send-native-event';

const openExternalLink = (url: string) => {
  if (isCarvanaNativeApp()) {
    sendNativeEvent({
      event: 'link',
      payload: {
        url,
        linkType: 'browser'
      },
      source: 'purchase'
    });
    return;
  }

  window.open(url, '_blank');
};

export default openExternalLink;
